(function AdzukiPexels($, Adzuki)
{
    const component = {
        emits : ['image-service'],
        inject: {
            openToast: {
                default: () => undefined
            },
        },
        props: {
            sectionInfo: {
                type: Object,
            },
            selectionFeedback: {
                type   : Boolean,
                default: false,
            }
        },
        template: `
          <div id="adzuki-image-service" class="col">
              <div id="image-service-search" class="row mb-2">
                <div class="alert alert-info no-icon col-12 col-md-10 mb-2 mx-auto" role="alert">
                  <ul class="icon-bullets">
                    <li>Select images or videos from the search results to save them into Maxx Media.</li>
                    <li>All files saved from this tool are free to use in all areas of CP Maxx and the Website Admin and do NOT need Home Office approval.</li>
                    <li>All files are subject to the following <a :href="termsLink" target="_blank">Terms and Conditions</a></li>
                  </ul>
                </div>
                <div class="col-12 col-md-10 mt-2 mx-auto">
<!--                  <div class="row mb-4 pb-1">
                    <h4>Image Service</h4>
                    <div class="radio-row">
                        <div class="form-check form-check-inline">
                          <input
                              class="form-check-input"
                              type="radio"
                              name="selectedImageService"
                              id="selectedService-pexels"
                              v-model="selectedImageService"
                              :value="'pexels'"
                          >
                          <label class="form-check-label" for="selectedService-pexels">
                            Pexels
                          </label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                              class="form-check-input"
                              type="radio"
                              name="selectedImageService"
                              id="selectedService-unsplash"
                              v-model="selectedImageService"
                              :value="'unsplash'"
                          >
                          <label class="form-check-label" for="selectedService-unsplash">
                            Unsplash
                          </label>
                        </div>
                    </div>
                  </div>-->
                  <div class="row mb-2 pb-1">
                      <h4>File Type</h4>
                      <div class="radio-row">
                          <div class="form-check form-check-inline" v-if="!allowedTypes || allowedTypes.includes('image')">
                            <input
                                class="form-check-input"
                                type="radio" 
                                name="selectedFileType" 
                                id="selectedFileType-image"
                                v-model="selectedFileType"
                                value="image"
                            >
                            <label class="form-check-label" for="selectedFileType-image">
                              Image
                            </label>
                          </div>
                          <div class="form-check form-check-inline" v-if="(!allowedTypes || allowedTypes.includes('video')) && selectedImageService === 'pexels'">
                            <input 
                                class="form-check-input"
                                type="radio"
                                name="selectedFileType"
                                id="selectedFileType-video"
                                v-model="selectedFileType"
                                value="video"
                                >
                            <label class="form-check-label" for="selectedFileType-video">
                              Video
                            </label>
                          </div>
                      </div>  
                  </div>
                  <div class="row mb-2">
                    <label class="form-label" for="searchTerm">Search {{ selectedFileType }}s by term</label>
                    <div class="input-group">
                        <input
                          type="text"
                          id="searchTerm"
                          name="searchTerm"
                          placeholder="Search"
                          v-model="searchTerm"
                          class="form-control my-1"
                          @keyup.enter="searchImages"
                        />
                    </div>
                  </div>
                  <div class="d-flex mb-4 align-items-center justify-content-start">
                    <button type="button" class="btn btn-primary"  @click="searchImages">Search</button>
                    <a class="btn btn-link" @click="resetSearch">Reset</a>
                  </div>
                </div>
              </div>
              <div id="image-service-results" class="row">
                <div class="col-12 col-md-10 mx-auto">
                  <template v-if="!isLoading">
                    <div 
                      v-if="normalizeResults.length > 0"
                      id="image-service-results-container"
                      class="d-grid gap-3"
                    >
                      <div v-for="item in normalizeResults" :key="item.id" class="image-search-result">
                      <img :src="item.imageUrl" :alt="item.authorName"/>
                      <div class="select-box d-flex align-items-center" v-if="!isSelectionActive(item)">
                        <button type="button" class="btn btn-primary p-2 me-1" @click="selectResult(item)">Select</button>
                        <a :href="item.pageUrl" class="btn btn-default p-2 ms-1" target="_blank">
                          <i class="fas fa-search"></i> View
                        </a>
                      </div>
                      <div
                        class="selection-feedback"
                        v-if="isSelectionActive(item)"
                        role="status"
                        aria-label="Selected"
                      >
                        <span class="selection-feedback-check" aria-hidden="true">
                          <i class="fas fa-check"></i>
                        </span>
                      </div>
                      <div class="artist-box badge text-uppercase">
                          <a class="text-wrap" :href="item.authorUrl" target="_blank" rel="noopener noreferrer" :title="'Photo by '+ item.authorName +' on '+ selectedImageService +''">
                            {{ item.authorName }}
                          </a>
                      </div>  
                    </div>
                    </div>
                    <div class="row my-4" v-if="normalizeResults.length > 0 && normalizeResults.length < resultsCount">
                      <div class="col-12 text-center">
                        <p class="pagination-text mb-0 mt-1"> Displaying <strong>{{ normalizeResults.length }}</strong> of <strong>{{ resultsCount }}</strong> media items</p>
                      </div>
                      <div class="col-12 text-center" >
                        <a class="btn btn-outline-primary btn-rounded mt-3" @click.prevent="loadMoreRows">Load More</a>
                      </div>
                    </div>
                  </template>
                  <div v-if="isLoading">
                    <adzuki-loading></adzuki-loading>
                  </div>
                </div>
              </div>
          </div>
        `,
        data() {
            return {
                searchTerm          : '',
                selectedFileType    : 'image',
                selectedImageService: 'pexels',
                searchResults       : [],
                resultsCount        : 0,
                isLoading           : false,
                pageNumber          : 1,
                totalPages          : null,
                termsLink           : 'https://www.pexels.com/terms-of-service/',
                perSearch           : 15,
                shownItems          : 15,
                loadMore            : false,
                allowedTypes        : null,
                activeResultKey     : null,
                selectionTimer      : null
            };
        },
        computed: {
            normalizeResults() {
                const results = Array.isArray(this.searchResults) ? this.searchResults : [];
                if (this.selectedImageService === 'pexels') {
                    if (this.selectedFileType === 'image') {
                        return results.map((p) => ({
                            provider   : 'pexels',
                            filename   : (p?.url || '').replace(/\/+$/, '').split('/').pop() || String(p.id),
                            type       : this.selectedFileType,
                            id         : p?.id ?? null,
                            imageUrl   : p?.src?.large || p?.src?.original || p?.src?.medium || '',
                            authorName : p?.photographer || '',
                            authorUrl  : p?.photographer_url || '',
                            pageUrl    : p?.url || '',
                            downloadUrl: p?.src?.large || p?.src?.original || p?.src?.medium || ''
                        }));
                    }

                    return results.map((p) => {
                        const videoFiles = p?.video_files || [];
                        const videoPictures = p?.video_pictures || [];

                        const vidSrc = videoFiles[Math.floor(videoFiles.length / 2)]?.link || '';
                        const thumbSrc = videoPictures[Math.floor(videoPictures.length / 2)]?.picture || '';
                        const duration = Number(p?.duration);

                        return {
                            provider   : 'pexels',
                            filename   : (p?.url || '').replace(/\/+$/, '').split('/').pop() || String(p.id),
                            type       : this.selectedFileType,
                            id         : p?.id ?? null,
                            imageUrl   : thumbSrc || '',
                            authorName : p?.user?.name || '',
                            authorUrl  : p?.user?.url || '',
                            pageUrl    : p?.url || '',
                            downloadUrl: vidSrc || '',
                            duration   : Number.isFinite(duration) && duration > 0 ? Math.floor(duration) : null
                        };

                    });

                }

                return results.map((u) => ({
                    provider   : 'unsplash',
                    filename   : u?.slug || '',
                    type       : this.selectedFileType,
                    id         : u?.id ?? null,
                    imageUrl   : u?.urls?.regular || u?.urls?.full || '',
                    authorName : u?.user?.name || u?.user?.username || '',
                    authorUrl  : u?.user?.links?.html || '',
                    pageUrl    : u?.links?.html || '',
                    downloadUrl: u?.links?.download || ''
                }));
            },
        },
        methods: {
            resultKey(item) {
                return [
                    item.provider,
                    item.type,
                    item.id ?? item.filename,
                ].join(':');
            },
            isSelectionActive(item) {
                return this.selectionFeedback
                    && this.activeResultKey === this.resultKey(item);
            },
            clearSelectionFeedback() {
                if (this.selectionTimer !== null) {
                    window.clearTimeout(this.selectionTimer);
                    this.selectionTimer = null;
                }

                this.activeResultKey = null;
            },
            selectResult(item) {
                this.$emit('image-service', [item]);

                if (!this.selectionFeedback) {
                    return;
                }

                this.clearSelectionFeedback();
                this.activeResultKey = this.resultKey(item);
                this.selectionTimer = window.setTimeout(() => {
                    this.activeResultKey = null;
                    this.selectionTimer  = null;
                }, 1000);
            },
            async searchImages() {
                let serviceUrl = '';
                let accessKey  = '';

                if (this.selectedImageService === 'pexels') {
                    accessKey  = 'KfrRpY0Tnu5JlUg2lhRgNqikPjHMZeBmoKAd2JToRR9dOOyEWztN7ISE';
                    if ( this.selectedFileType === 'image' ) {
                        serviceUrl = 'https://api.pexels.com/v1/search?page=' + this.pageNumber + '&per_page='+ this.perSearch +'&query=' + this.searchTerm;
                    } else {
                        serviceUrl = 'https://api.pexels.com/videos/search?page=' + this.pageNumber + '&per_page='+ this.perSearch +'&query=' + this.searchTerm;
                    }
                } else {
                    accessKey  = 'wqhYNs0hDmJUSYrQEk6RiL1_nigsUah-ddGQrItzZSw';
                    serviceUrl = 'https://api.unsplash.com/search/photos?page=' + this.pageNumber + '&per_page='+ this.perSearch +'&query=' + this.searchTerm;
                }
                const authorizationValue = (this.selectedImageService === 'pexels')
                        ? accessKey
                        : ('Client-ID ' + accessKey);

                if (!this.loadMore) {
                    this.isLoading = true;
                }

                try {
                    const response = await fetch(serviceUrl, {
                        method : 'GET',
                        headers: {
                            Authorization: authorizationValue
                        }
                    });

                    if (!response.ok) {
                        throw new Error('Image search failed with status ' + response.status);
                    }

                    const data = await response.json();
                    let results = [];
                    console.log(data);

                    if (this.selectedImageService === 'pexels') {

                        if (this.selectedFileType === 'image') {
                            results = data.photos;
                        } else {
                            results   = data.videos;
                        }
                        this.resultsCount = data.total_results;
                        this.totalPages = Math.ceil(Number(data.total_results) / Number(this.perSearch));
                    } else {
                        results   = data.results;
                        this.resultsCount  = data.total;
                        this.totalPages    = data.total_pages;
                    }

                    if (this.loadMore) {
                        this.searchResults.push(...results);
                        this.shownItems += results.length;
                    } else {
                        this.searchResults = results;
                        this.shownItems    = results.length;
                    }


                } finally {
                    this.isLoading = false;
                    this.loadMore  = false;
                }
            },
            loadMoreRows() {
                this.pageNumber++;
                this.loadMore = true;
                this.searchImages();
            },
            resetSearch() {
                this.clearSelectionFeedback();
                Object.assign(this.$data, this.$options.data.call(this));
            }
        },
        watch: {
            selectedFileType(newVal) {
                this.searchResults = [];
            },
            selectedImageService(newVal) {
               this.searchResults = [];

                if (newVal === 'pexels') {
                    this.termsLink = 'https://www.pexels.com/terms-of-service/';
                } else {
                    this.termsLink = 'https://help.unsplash.com/en/collections/1463188-unsplash-license';
                    this.selectedFileType = 'image';
                }
            },
        },
        mounted() {
            if (this.sectionInfo?.allowed_types) {
                this.allowedTypes = this.sectionInfo.allowed_types.split(',').map(t => t.trim());
                if (!this.allowedTypes.includes('image')) {
                    this.selectedFileType = 'video';
                }
            }
        },
        beforeUnmount() {
            this.clearSelectionFeedback();
        }
    };

    Adzuki.VueComponents.AdzukiPexels = component;
}(jQuery, window.Adzuki || {}));
